import axios from 'axios'
import { BaseApi } from './baseApi.js'

// 加载状态管理
let loadingCount = 0
let loadingElement = null

// 显示加载提示
const showLoading = () => {
  if (loadingCount === 0) {
    // 创建原生加载提示元素
    loadingElement = document.createElement('div')
    loadingElement.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
      font-size: 16px;
      color: white;
    `
    loadingElement.innerHTML = `
      <div style="text-align: center;">
        <div style="width: 40px; height: 40px; border: 4px solid #f3f3f3; border-top: 4px solid #3498db; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto 10px;"></div>
        <div>加载中...</div>
        <style>
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        </style>
      </div>
    `
    document.body.appendChild(loadingElement)
  }
  loadingCount++
}

// 隐藏加载提示
const hideLoading = () => {
  loadingCount--
  if (loadingCount <= 0) {
    loadingCount = 0
    if (loadingElement && loadingElement.parentNode) {
      loadingElement.parentNode.removeChild(loadingElement)
      loadingElement = null
    }
  }
}

// 创建axios实例
const service = axios.create({
  baseURL: BaseApi,
  timeout: 30000, // 增加超时时间到30秒
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {


    // 添加token到请求头
    const token = localStorage.getItem('token') || ''
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }

    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 根据你的后端返回格式调整
    if (response.status === 200) {
      return response
    } else {
      // 处理业务错误
      console.error('业务错误:', response.data?.msg || response.data?.message || '请求失败')
      return Promise.reject(new Error(response.data?.msg || response.data?.message || '请求失败'))
    }
  },
  error => {
    // 对响应错误做点什么
    console.error('响应错误:', error)

    if (error.response) {
      switch (error.response.status) {
        case 401:
          // token过期，跳转到登录页
          console.error('登录过期，请重新登录')
          // 这里可以添加跳转登录页的逻辑
          break
        case 403:
          console.error('拒绝访问')
          break
        case 404:
          console.error('请求地址不存在')
          break
        case 500:
          console.error('服务器内部错误')
          break
        default:
          console.error('网络错误')
      }
    } else if (error.request) {
      console.error('网络错误，请检查网络连接')
    } else {
      console.error('请求配置错误:', error.message)
    }

    return Promise.reject(error)
  }
)

// 统一的请求方法
export const request = (config) => {
  // 默认显示加载提示，除非明确设置 showLoading 为 false
  const showLoadingTip = config.showLoading !== false

  if (showLoadingTip) {
    showLoading()
  }

  return service(config)
    .then(response => {
      if (showLoadingTip) {
        hideLoading()
      }
      return response
    })
    .catch(error => {
      if (showLoadingTip) {
        hideLoading()
      }
      return Promise.reject(error)
    })
}

// 封装GET请求
export const get = (url, params = {}, showLoading = true) => {
  return request({
    url,
    method: 'GET',
    params,
    showLoading
  })
}

// 封装POST请求
export const post = (url, data = {}, showLoading = true) => {
  return request({
    url,
    method: 'POST',
    data,
    showLoading
  })
}

// 封装PUT请求
export const put = (url, data = {}, showLoading = true) => {
  return request({
    url,
    method: 'PUT',
    data,
    showLoading
  })
}

// 封装DELETE请求
export const del = (url, params = {}, showLoading = true) => {
  return request({
    url,
    method: 'DELETE',
    params,
    showLoading
  })
}

// 文件上传
export const upload = (url, formData, showLoading = true) => {
  return request({
    url,
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    showLoading
  })
}

export default service